import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { Link } from 'src/components/link';
import { config } from 'src/config/config';
import { useTabletMediaQuery } from 'src/utils/breakpoints-utils';

import { StyledContainer, StyledContent, StyledInput } from './delivery-method.styled';

interface OwnProps {
  name: string;
  description: string;
  price: string;
  moreInformation?: string;
}

type Props = OwnProps & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'name'>;

export const DeliveryMethod: FunctionComponent<Props> = (props) => {
  const { name, price, description, moreInformation, ...rest } = props;

  const renderLink = () =>
    moreInformation && (
      <Link variant="paragraph2" maxBreakpoint={Breakpoint.TABLET} target="_blank" href={config.DELIVERY_FAQ_LINK}>
        {moreInformation}
      </Link>
    );

  const isOnTablet = useTabletMediaQuery();

  return (
    <StyledContainer>
      <StyledInput type="radio" name="delivery-method" {...rest} />
      <StyledContent
        label={name}
        value={isOnTablet ? price : undefined}
        note={{
          label: description,
          value: renderLink(),
        }}
      />
    </StyledContainer>
  );
};
